import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { PAGE_PROPS } from "../constants/common";
import { IUserItem } from "../../Components/users/types";
import { CUSTOMERS_INITIAL_STATE } from "../constants/customers.constants";
import { ISearchAPIPayload } from "../types/common";

export const getAllPagedCustomers = createAsyncThunk(
  "customers/getAllPaged",
  async (data: ISearchAPIPayload) => {
    const response = await axios.post(
      "/api/Customer/New/GetPagedCustomers",
      data
    );
    return response.data;
  }
);

export const updateCustomer = createAsyncThunk(
  "customers/update",
  async (data: Partial<IUserItem>) => {
    const response = await axios.post("/api/Customer/New/UpdateCustomer", data);
    return response.data;
  }
);

export const blockCustomer = createAsyncThunk(
  "customers/block",
  async (id: number) => {
    const response = await axios.post(
      "/api/Customer/New/DeleteOrBlockCustomer/" + id
    );
    return response.data;
  }
);

export const getCustomerVehicles = createAsyncThunk(
  "customers/vehicles",
  async (id: number) => {
    const response = await axios.get(
      "/api/Customer/New/GetCustomerVehicles/" + id
    );
    return response.data;
  }
);

export const getCustomerAttachments = createAsyncThunk(
  "customers/attachments",
  async (id: number) => {
    const response = await axios.get(
      "/api/Customer/New/GetCustomerAttachment/" + id
    );
    return response.data;
  }
);

export const customersSlice = createSlice({
  name: "customers",
  initialState: CUSTOMERS_INITIAL_STATE,
  reducers: {
    onChangeCustomersScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    onChangeCustomersList: (state, action) => {
      state.pageProps = action.payload;
    },
    onSelectCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPagedCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPagedCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.result ?? PAGE_PROPS;
        state.error = null;
      })
      .addCase(getAllPagedCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(updateCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(blockCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(blockCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(blockCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(getCustomerVehicles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerVehicles.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.selectedCustomerVehicles = action.payload?.result ?? {};
      })
      .addCase(getCustomerVehicles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })

      .addCase(getCustomerAttachments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerAttachments.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCustomerAttachments = action.payload?.result ?? {};
        state.error = null;
      })
      .addCase(getCustomerAttachments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      });
  },
});

export const {
  onChangeCustomersScreen,
  onChangeCustomersList,
  onSelectCustomer,
} = customersSlice.actions;

export default customersSlice.reducer;
